module.exports = __webpack_public_path__ + "static/img/middle3.7b5ec1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/middle3.jpg
// module id = 1Q+z
// module chunks = 9